import React, { useState } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetDomainesQuery,
} from "../../redux/api/coachApi";

const CategoriesView = () => {
  const [newCategory, setNewCategory] = useState({
    nom: "",
    domaine: 0, // id du domaine choisi
    description: "",
  });
  const [editingCategory, setEditingCategory] = useState(null);
  const [error, setError] = useState("");

  // RTK Query hooks
  const {
    data: categories,
    isLoading,
    error: fetchError,
  } = useGetCategoriesQuery();
  const { data: domaines = [], isLoading: isDomainesLoading } = useGetDomainesQuery();
  const [addCategory, { isLoading: isAdding }] = useAddCategoryMutation();
  const [updateCategory, { isLoading: isUpdating }] =
    useUpdateCategoryMutation();
  const [deleteCategory, { isLoading: isDeleting }] =
    useDeleteCategoryMutation();

   const handleSubmit = async (e) => {
     e.preventDefault();
     if (!newCategory.nom.trim() || !newCategory.domaine) {
       setError("Le nom de la catégorie est requis.");
       return;
     }
     setError("");

     try {
       if (editingCategory) {
         await updateCategory({
           id: editingCategory.id,
           ...newCategory
         }).unwrap();
         console.log("Catégorie mise à jour !");
       } else {
         console.log("Sending category:", newCategory);
         await addCategory(newCategory).unwrap();
       }
       setNewCategory({ nom: "" , domaine: 0, description: "" });
       setEditingCategory(null);
     } catch (err) {
       setError(
         editingCategory
           ? "Erreur lors de la mise à jour de la catégorie."
           : "Erreur lors de l'ajout de la catégorie."
       );
       console.error("Error submitting category:", err);
     }
   };

  const handleEdit = (category) => {
    setEditingCategory(category);
    setNewCategory({
         nom: category.nom ,
         domaine: category.domaine?.id ?? category.domaine,
        description: category.description || "",});
  };

  const handleDelete = async (id) => {
      console.log("Deleting category ID:", id);
    if (
      window.confirm("Êtes-vous sûr de vouloir supprimer cette catégorie ?")
    ) {
      try {
        await deleteCategory(id).unwrap();
      } catch (err) {
        setError("Erreur lors de la suppression de la catégorie.");
        console.error("Error deleting category:", err);
      }
    }
  };

  if (isLoading) {
    return <div className="loading">Chargement des catégories...</div>;
  }

  if (fetchError) {
    return (
      <div className="error">
        Erreur lors du chargement des catégories: {fetchError.message}
      </div>
    );
  }

  return (
    <div className="categories-view-container">
      {/* Form Card */}
      <div className="form-card">
        <h2>
          {editingCategory ? "Modifier la Catégorie" : "Ajouter une Catégorie"}
        </h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="categoryName">Nom de la Catégorie</label>
            <input
              type="text"
              id="categoryName"
              className="form-control"
              value={newCategory.nom}
              onChange={(e) =>
                setNewCategory({ ...newCategory, nom: e.target.value })
              }
              placeholder="Entrez le nom de la catégorie"
            />
            <select
             className="form-control mt-2"
              value={newCategory.domaine}
              onChange={(e) =>
                setNewCategory({ ...newCategory,  domaine: parseInt(e.target.value)  })
              }
            >
              {/* ici il faut boucler sur la liste des domaines disponibles */}
              <option value={0}> Choisir un domaine </option>
              {domaines.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>

            <textarea
              placeholder="Description (optionnelle)"
              className="form-control mt-2"
              value={newCategory.description}
              onChange={(e) =>
                setNewCategory({ ...newCategory, description: e.target.value })
              }
            />
          </div>
          <button
            type="submit"
            className="btn-add-middle"
            disabled={isAdding || isUpdating}
          >
            {editingCategory ? "Mettre à jour" : "Ajouter"}
          </button>
        </form>
      </div>

      {/* List Card */}
      <div className="list-card">
        <h2>Liste des Catégories</h2>
        {categories && categories.length > 0 ? (
          <div className="list-items-container">
            {categories.map((category) => (
              <div key={category.id} className="list-item">
                <div className="content">
                  <h3>{category.nom}</h3>
                </div>
                <div className="actions">
                  <button
                    className="btn-icon"
                    onClick={() => handleEdit(category)}
                    disabled={isUpdating}
                  >
                    <FiEdit2 />
                  </button>
                  <button
                    className="btn-icon"
                    onClick={() => handleDelete(category.id)}
                    disabled={isDeleting}
                  >
                    <FiTrash2 />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">Aucune catégorie trouvée.</p>
        )}
      </div>
    </div>
  );
};

export default CategoriesView;
